import { useEffect, useState } from "react";
import { getLocale, useSelector, shallowEqual } from "umi";
import moment from 'moment'
import { KEY_DAYS_DEFAULT_VALUE, LANGUAGE_MAP } from '@/pages/dashboard/_config/constant';

import { downLoadApi, getApiData } from "@/pages/dashboard/services/common";
import { formatFilterValues } from "@/pages/dashboard/utils/utils";
import { useOverLimitTrigger } from "@/pages/dashboard/components/OverLimitTip";
import { TableReqParams } from "./_type";

const useData = (config: any, formValue: any, filterLoading: boolean, tag: string, accumulated: string[]) => {
    const { api } = config;
    const { tableApi, tableDownloadApi } = api || {}
    const gameCode = useSelector((state: any) => {
        return state?.dashboard?.currentGame?.game_code
    }, shallowEqual);
    const [componentData, setComponentData] = useState({
        avg: [],
        page: 1,
        rentention_days: [],
        total_record: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { overLimitBarTriggerKey, handleResponse } = useOverLimitTrigger();

    // 点击筛选器的时候
    useEffect(() => {
        if (!formValue) return;
        !filterLoading && getRetentionDataFunc(KEY_DAYS_DEFAULT_VALUE, { pageIndex: 1, pageSize: 10 }, [])
    }, [formValue, tag])

    const getRetentionDataFunc = (keyDays: number, paging: any, sort: string[]) => {
        // const { timeType, filterValue } = formValue
        const { rangeTime, timeType, diff, ...filters } = formValue
        const cycle = timeType?.replace(timeType[0], timeType[0]?.toLowerCase())
        let desc = true
        const orderBy = sort.map((value: any) => {
            desc = value?.order === 'desc'
            return value?.code?.replace('__heat_', '')
        })
        const params = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
            end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
            tag: tag,
            cycle: cycle,
            column_len: keyDays,
            group: accumulated?.filter(item => item !== 'date'),
            desc,
            order_by: orderBy?.length ? orderBy : ['date'],
            page: paging?.pageIndex,
            page_size: paging?.pageSize,
        }
        setLoading(true);
        const locale = LANGUAGE_MAP[getLocale()]

        getApiData(`${tableApi}?language=${locale}`, params).then((result: any) => {
            setError(false)
            // testTableData
            setComponentData(result);
            handleResponse(result?.front_logical_flag);
            setLoading(false);
        }).catch((err: any) => {
            setError(true)
            setLoading(false);
        })
    }

    return {
        getRetentionDataFunc,
        // nodata 不在此封装，因为可能是接口的个别项目nodata
        componentData,
        loading,
        error,
        overLimitBarTriggerKey,
    }
}

export default useData;